import { render } from "./stream.vue?vue&type=template&id=6a8cdcfa"
import script from "./stream.vue?vue&type=script&lang=js"
export * from "./stream.vue?vue&type=script&lang=js"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__